import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectParamBookProgressLoaded } from './book-progress.selectors';

@Injectable({
  providedIn: 'root',
})
export class BookProgressFacade {
  private readonly store: Store = inject(Store);

  public readonly paramBookProgressLoaded: Signal<boolean> =
    this.store.selectSignal(selectParamBookProgressLoaded);
}
